import styled from 'styled-components';
import { PriceWrapper } from '../styles';

export const PriceWrapperRed = styled(PriceWrapper)`
  color: ${({ theme }) => theme.semanticColors.redDark};
`;
